import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { availabilityStages } from '../../data/home';
import { fadeUp } from '../../utils/motion';

/** What is available now and what comes next. */
export function HomeAvailability() {
  return <section aria-labelledby="availability-title" className="bg-white border-b border-line py-20 lg:py-28" data-id="element-1123" data-mp="xcqcbclufzit">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1124" data-mp="1u2r6xs8w9a81">
        <motion.h2 {...fadeUp} id="availability-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight max-w-2xl mb-12" data-id="element-1125" data-mp="1u53lrwjcv4gv">
          What is available and what comes next
        </motion.h2>

        <motion.ol {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-0 md:divide-x divide-line" data-id="element-1126" data-mp="1gb2vlr6gyps4">
          {availabilityStages.map((stage, index) => <li key={stage.status} className={`flex flex-col ${index === 0 ? 'md:pr-8' : index === 2 ? 'md:pl-8' : 'md:px-8'}`} data-id="element-1127" data-mp="28zzzuqduim1v" data-mpi={index}>
              <p className={`text-sm font-semibold ${index === 0 ? 'text-teal' : 'text-ink-muted'}`} data-id="element-1128" data-mp="24vb9amld0ltt">{stage.status}</p>
              <h3 className="mt-2 font-heading font-bold text-xl text-ink-dark" data-id="element-1129" data-mp="29vyw0w2k2gi8">{stage.title}</h3>
              <p className="mt-3 text-ink-muted leading-relaxed" data-id="element-1130" data-mp="1w0dcv5j06qxq">{stage.body}</p>
            </li>)}
        </motion.ol>

        <a href="/roadmap" className="mt-10 inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1131" data-mp="1m4jrcwnb3n3t">
          See the development roadmap
          <ArrowRight size={16} aria-hidden="true" data-id="element-1132" data-mp="1d4wyx0ck1rmw" />
        </a>
      </div>
    </section>;
}